export default "__VITE_ASSET__CBj22isU__"